export const ONE_MINUTE_REFRESH_INTERVAL = 60 * 1000

export enum OperatorViewLSKeys {
  SliderSettings = 'control_operator_slider_settings',
  ElectricityChartSettings = 'control_operator_electricity_chart_settings',
  CommentsSidebarSettings = 'control_operator_comments_sidebar_settings',
  ChartCardSettings = 'control_operator_chart_card_settings'
}
